<template>
  <div class="usertools">
  <span class="username">{{ email }}</span>
  <span class="logout"><a v-if="uuid" @click="logout" class="link">Logout</a></span>
  </div>
</template>

<script>

import _ from 'lodash'
import { mapGetters } from 'vuex';

//var log = console.log

export default {
  components: {
  },
  computed: {
      ...mapGetters({
          uuid : 'uuid',
          email : 'email',
      })
  },
  data: function() { 
    return {
      showLogin : true,
      showReg : false,
      u : {
          email: '',
          name_last: '',
          name_first: '',
          name_display: '',
          auth: '',
      },
      message : {msg:'',icon:'',header:''}
    }
  },
  methods: {
      setMessage: function(msg) {
this.$store.commit('showMessage', { content: msg, color: 'info' })
      },
      setError: function(msg) {
this.$store.commit('showMessage', { content: msg, color: 'error' })
      },
      logout: function() {
          var self = this;
          this.$store.dispatch('logout').then(() => {}, 
            error => { self.setError(_.get(error,'message', error)) })
          window.location.href = '/'

      },
      login: function() {
          var self = this;

          this.$store.dispatch('login',{email:self.u.email,auth:self.u.auth}).then(() => {}, 
            error => { self.setError(_.get(error,'message', error)) })

      },
      register: function() {
          var self = this;
          this.message = {'header':'','icon':'wait', msg:'Registering your account ...'};

          this.$store.dispatch('register',this.u).then((p) => {
             let msg = p['message'] 
             this.message = {'header':'Complete','icon':'info', msg:msg};
          }, error => { self.setError(_.get(error,'message', error)) })
      }
  }
}
</script>

<style scoped>
.link {
    cursor: pointer;
    font-weight: bolder;
}
.usertools {
    float: right;
    margin-right: 10px;
}
.logout {
    padding-left: 5px;
}
</style>
